<script setup lang="ts">
  import {
    Dialog,
    DialogContent,
    DialogDescription,
    DialogFooter,
    DialogHeader,
    DialogTitle,
  } from "@/components/ui/dialog";
  import { Button } from "@/components/ui/button";
  import { useUnsavedChangesDialog } from "@/utils/composables/useUnsavedChangesGuard";

  const { isOpen, confirmLeave, cancelLeave } = useUnsavedChangesDialog();
</script>

<template>
  <!-- Non-dismissable: only the two buttons close it, so navigation stays paused until the user decides. -->
  <Dialog :open="isOpen">
    <DialogContent
      class="font-sans"
      :show-close-button="false"
      @escape-key-down.prevent
      @interact-outside.prevent
      @pointer-down-outside.prevent>
      <DialogHeader>
        <DialogTitle>Unsaved changes</DialogTitle>
        <DialogDescription>
          You have unsaved changes on this page. If you leave now, they will be lost.
        </DialogDescription>
      </DialogHeader>
      <DialogFooter>
        <Button
          variant="outline"
          @click="cancelLeave">
          Stay on page
        </Button>
        <Button
          variant="destructive"
          @click="confirmLeave">
          Leave anyway
        </Button>
      </DialogFooter>
    </DialogContent>
  </Dialog>
</template>
